import { InjectionToken } from "@angular/core";
import { OTPVerificationCustomerModel } from "../model/create-customer.model";
import { Observable } from "rxjs";
import { BaseResponseModel } from "app/core/models";

export const CUSTOMER_OTP_VERIFICATION_SERVICE = new InjectionToken('customer otp verification service ...')
export interface CustomerOtpVerificationInterface{

verifyCustomerOTP(customerOTPVerificationData:OTPVerificationCustomerModel):Observable<BaseResponseModel<string>>;
}